import { render, staticRenderFns } from "./image.vue?vue&type=template&id=69eb3016"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69eb3016')) {
      api.createRecord('69eb3016', component.options)
    } else {
      api.reload('69eb3016', component.options)
    }
    module.hot.accept("./image.vue?vue&type=template&id=69eb3016", function () {
      api.rerender('69eb3016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/image.vue"
export default component.exports